(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-mobile-atc-flyout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const flyout = document.getElementById('mobile-atc-flyout');
  if (!flyout) return;
  
  const quantityInput = flyout.querySelector('.quantity-input');
  const decreaseBtn = flyout.querySelector('.quantity-decrease');
  const increaseBtn = flyout.querySelector('.quantity-increase');
  const form = flyout.querySelector('form');
  
  // Show/hide flyout based on mobileActionArea visibility
  function toggleFlyoutVisibility() {
    const mobileActionArea = document.getElementById('mobileActionArea');
    if (!mobileActionArea) return;
    
    const actionAreaRect = mobileActionArea.getBoundingClientRect();
    const isActionAreaVisible = actionAreaRect.bottom > 0;
    
    if (isActionAreaVisible) {
      flyout.classList.remove('visible');
    } else {
      flyout.classList.add('visible');
    }
  }
  
  // Initial check
  toggleFlyoutVisibility();
  
  // Listen for scroll events
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(toggleFlyoutVisibility, 10);
  });
  
  // Listen for resize events
  window.addEventListener('resize', function() {
    toggleFlyoutVisibility();
  });
  
  // Quantity control functionality
  function updateQuantity(change) {
    const currentValue = parseInt(quantityInput.value) || 1;
    const min = parseInt(quantityInput.min) || 1;
    const max = parseInt(quantityInput.max) || Infinity;
    const step = parseInt(quantityInput.step) || 1;
    
    let newValue = currentValue + (change * step);
    newValue = Math.max(min, Math.min(max, newValue));
    
    quantityInput.value = newValue;
    
    // Update button states
    decreaseBtn.disabled = newValue <= min;
    increaseBtn.disabled = newValue >= max;
  }
  
  decreaseBtn.addEventListener('click', () => updateQuantity(-1));
  increaseBtn.addEventListener('click', () => updateQuantity(1));
  
  // Handle input validation
  quantityInput.addEventListener('input', function() {
    const value = parseInt(this.value);
    const min = parseInt(this.min) || 1;
    const max = parseInt(this.max) || Infinity;
    
    if (isNaN(value) || value < min) {
      this.value = min;
    } else if (value > max) {
      this.value = max;
    }
    
    // Update button states
    decreaseBtn.disabled = this.value <= min;
    increaseBtn.disabled = this.value >= max;
  });
  
  // Listen for variant changes from the main product form
  document.addEventListener('variant:change', function(event) {
    const variant = event.detail.variant;
    if (variant) {
      // Update hidden input
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }
      
      
      // Update quantity rules
      const min = variant.quantity_rule?.min || 1;
      const max = variant.quantity_rule?.max || null;
      const step = variant.quantity_rule?.increment || 1;
      
      quantityInput.min = min;
      quantityInput.step = step;
      if (max) {
        quantityInput.max = max;
      } else {
        quantityInput.removeAttribute('max');
      }
      
      // Reset quantity to minimum if current value is below new minimum
      if (parseInt(quantityInput.value) < min) {
        quantityInput.value = min;
      }
      
      // Update button states
      decreaseBtn.disabled = quantityInput.value <= min;
      increaseBtn.disabled = max ? quantityInput.value >= max : false;
      
      // Update add to cart button
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('opacity-50', 'cursor-not-allowed');
          submitBtn.textContent = variant.requires_selling_plan ? 
            '{{ "product.general.pre_order_button" | t | escape }}' : 
            '{{ "product.general.add_to_cart_button" | t | escape }}';
        } else {
          submitBtn.disabled = true;
          submitBtn.classList.add('opacity-50', 'cursor-not-allowed');
          submitBtn.textContent = '{{ "product.general.sold_out_button" | t | escape }}';
        }
      }
    }
  });
  
  // Initialize button states
  const min = parseInt(quantityInput.min) || 1;
  const max = parseInt(quantityInput.max) || Infinity;
  decreaseBtn.disabled = quantityInput.value <= min;
  increaseBtn.disabled = quantityInput.value >= max;
});
  } catch(e) { console.error(e); }
})();

})();
